import { render, staticRenderFns } from "./ViewSafe.vue?vue&type=template&id=2e6c962f"
import script from "./ViewSafe.vue?vue&type=script&lang=js"
export * from "./ViewSafe.vue?vue&type=script&lang=js"
import style0 from "./ViewSafe.vue?vue&type=style&index=0&id=2e6c962f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports